export default __webpack_public_path__ + "static/media/lines-no-1.31da1490.ogg";